import { render } from "./ServiceModal.vue?vue&type=template&id=61ba3682&scoped=true"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"

import "./ServiceModal.vue?vue&type=style&index=0&id=61ba3682&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ba3682"]])

export default __exports__